/** 部门管理API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/sys/department';
/**
 * 分页查询
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.Sys.Department> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询部门列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.Sys.Department> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询单个部门
 *
 * @param id 部门ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.Sys.Department> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存部门
 *
 * @param params 部门信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新部门信息
 *
 * @param params 部门信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除部门
 *
 * @param id 部门ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除部门
 *
 * @param ids 部门ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};

export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete
};
